<template lang="html">
  <div class="g-section" v-if="list && list.length > 0">
    <div class="g-title">
      <h2>{{ title }}</h2>
    </div>
    <div class="g-info">
      <div class="scroller-warp">
        <div class="ui-scroller">
          <ul :style="schedualWaresShow">
            <slot name="scroller-items"> </slot>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      schedualWaresShow: {
        width: '100%'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.g-section {
  margin-top: rem(20px);
  background: #ffffff;
  .g-title {
    display: flex;
    align-items: center;
    height: rem(100px);
    line-height: rem(100px);
    padding-left: rem(25px);
    padding-right: rem(25px);
    background: #fff;

    > h2 {
      flex: 1;
      font-size: rem(32px);
      font-weight: 600;

      > span {
        color: #999;
        font-size: rem(28px);
        font-weight: normal;
      }
      > i {
        font-weight: normal;
        color: #999;
        margin: 0 rem(10px);
      }
    }
    > a {
      align-self: flex-start;
      font-size: rem(26px);
    }
    .more {
      font-size: rem(26px);
      text-align: right;
    }
    .icon-jiantou {
      display: inline-block;
      font-size: rem(22px);
      transform: rotate(-90deg);
    }
  }
  .g-info {
  }
}
.scroller-warp {
  width: 100%;
  height: rem(210px);
  overflow: hidden;

  .ui-scroller {
    padding: 0;
    width: 100%;
    overflow-y: auto;
    ul {
      display: -webkit-box;

      li {
        width: rem(180px);
        height: rem(210px);
        box-sizing: border-box;
        margin-left: rem(25px);
        padding-bottom: rem(30px);
        overflow: hidden;
        position: relative;
        z-index: 2;
        // img{
        //     display: block;
        //     width: rem(150px);
        //     height: rem(150px);
        // }
        // .name{
        //     margin-top: rem(20px);
        //     padding-right: rem(8px);
        //     width: 100%;
        //     height: 1.2em;
        //     color: #121212;
        //     font-size: rem(26px);
        //     line-height: 1.3;
        //     word-break: break-all;
        //     -webkit-line-clamp: 1;
        // }
        &:last-child {
          margin-right: rem(20px);
        }
      }
    }
  }
}
</style>
